module.exports = __webpack_public_path__ + "static/media/设备.4411a6df.png";